import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpSection, HeaderAction, SearchBasicInfo, SearchMode, SearchOptionType, SearchRowInfo, SearchRowInfoSelect } from '@docpath/webcomponents';
import { Constants } from 'src/app/constants/constants';

import { Dge, DgeState } from '../../models/dge';
import { EnginesTableService } from '../table/engines-table.service';
import { EnginesHeaderService } from './engines-header.service';

@Component({
    selector: 'app-engines-header',
    templateUrl: './engines-header.component.html'
})
export class EnginesHeaderComponent implements OnChanges {

    @Input() dges: Dge[] = [];
    @Output() filtersChanged = new EventEmitter<Filter[]>();

    section = new DpSection({ name: 'engines', rows: [], header: 'engines-config.header.title', tooltip: 'engines-config.header.title-tooltip' });

    rightActions: HeaderAction[] = [];
    leftActions: HeaderAction[] = [];

    showSearch = false;

    private filters: Filter[] = [];

    searchAvailableOptions: SearchRowInfo[] = [
        new SearchRowInfo(true, Constants.CONF_ENGINES_ENGINE_NAME, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
        new SearchRowInfo(false, Constants.CONF_ENGINES_URL, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
        new SearchRowInfoSelect(false, Constants.CONF_ENGINES_STATUS, undefined, SearchMode.is, this.getStatusFilterOptions(), true, true),
        new SearchRowInfo(false, Constants.CONF_ENGINES_SINCLAIR_INDEX, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true)
    ];

    constructor(
        private readonly enginesHeaderService: EnginesHeaderService,
        private readonly enginesTableService: EnginesTableService,
        private readonly searchService: SearchService
    ) {
        this.rightActions = this.enginesHeaderService.getRightActions();
        const searchAction = this.enginesHeaderService.getSearchAction(this.rightActions);

        searchAction.action = () => {
            this.showSearch = !this.showSearch;
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line dot-notation
        if (changes['dges']) {
            this.leftActions = this.enginesHeaderService.getLeftActions(this.dges);
        }
    }

    getStatusFilterOptions(): Map<string, string> {
        return new Map<string, string>([
            [DgeState.RUNNING, DgeState.RUNNING],
            [DgeState.STOPPING, DgeState.STOPPING],
            [DgeState.STOPPED, DgeState.STOPPED],
            [DgeState.INTERRUPTED, DgeState.INTERRUPTED],
            [DgeState.UNLINKED, DgeState.UNLINKED]
        ]);
    }

    isSearchVisible(): boolean {
        return this.showSearch;
    }

    clearSearch(): void {
        this.filters = [];
        this.filtersChanged.emit(this.filters);
        this.enginesTableService.loadDges(this.filters, 1);
        this.leftActions = [];
    }

    sendSearch(currentFilters: Array<SearchBasicInfo>): void {
        this.filters = this.searchService.toFilters(currentFilters);
        this.filtersChanged.emit(this.filters);
        this.enginesTableService.loadDges(this.filters, 1);
        this.leftActions = [];
    }

    hideSearch(): void {
        this.showSearch = false;
    }

}